var map = {
	"./cadastro.svg": "834a",
	"./certificate.svg": "9942",
	"./home.svg": "f2a5",
	"./logo.svg": "a5f7",
	"./order_confirmed.svg": "9083",
	"./superhero.svg": "04cd",
	"./visual-data.svg": "03ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";